module.exports = __webpack_public_path__ + "static/media/4-gary.c7800dc0.png";